import * as preact from "preact";
import stores from "stores/stores";

import * as modalController from "modalController";
import Dialog from "views/Dialog";
import LanguageSelectorView from "views/LanguageSelectorView";
import * as walkthrough from "walkthrough";

/**
 * Display a modal dialog allowing the user to choose their first language and resolve the
 * returned promise once the user has selected and the choice has been saved to the user model.
 */
export const show = async () => {
  return new Promise<void>((resolve) => {
    modalController.show(
      preact.h(
        Dialog,
        { heading: "Choose Your First Language" },
        preact.h(
          "p",
          null,
          "Translations need a first language that differs from the " +
            "language you're reading."
        ),
        preact.createElement(LanguageSelectorView, {
          languageType: "first",
          setLanguage: async (languageCode: string) => {
            await stores.user.save({ firstLanguage: languageCode });
            await walkthrough.setAchievement("setLanguages", true);
            modalController.cancel();
            resolve();
          },
        })
      ),
      {
        clickToCancel: true,
        closeButton: true,
        width: 300,
      }
    );
  });
};
